export default __webpack_public_path__ + "static/media/sell-image5.d1514918.png";